/* unplugin-vue-components disabled */import script from "./ProjectDetailDetailRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetailDetailRight.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetailDetailRight.vue?vue&type=style&index=0&id=0ce45977&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce45977"]])

export default __exports__